<template>
  <div class="goods-preview">
    <template v-if="$$FormData.list_style === 'swiper'">
      <div
        class="goods-preview__list"
        :class="[$$FormData.list_style]"
        :style="{
          paddingLeft: ($$FormData.page_edge ) * 0.5 + 'px',
          paddingRight: ($$FormData.page_edge ) * 0.5 + 'px',
          marginLeft: (-($$FormData.goods_space / 2) ) * 0.5 + 'px',
          marginRight: (-($$FormData.goods_space / 2) ) * 0.5 + 'px'
        }"
      >
        <div class="swiper-goods-list">
          <div class="uni-swiper-wrapper">
            <div class="uni-swiper-slides">
              <div class="uni-swiper-slide-frame">
                <div class="uni-swiper-item" :class="`uni-swiper-item-${itemIndex + 1}`" v-for="(item, itemIndex) in swiperGoodsList" :key="itemIndex">
                  <div class="swiper-goods-item" :class="itemIndex === current && 'swiper-active'">
                    <div
                      class="a-item-goods"
                      :style="{backgroundColor: $$FormData.goods_background_color, borderColor: $$FormData.goods_border_color}"
                      :class="[$$FormData.goods_chamfer, $$FormData.goods_style]"
                    >
                      <div class="image-goods"
                           :style="[$$FormData.image_edge && {
                              margin: ($$FormData.image_edge ) * 0.5 + 'px'
                           }, {
                              borderRadius: ($$FormData.image_radius ) * 0.5 + 'px'
                           }]">
                        <div class="image-goods-inner" :style="{paddingTop: imagePaddingTopByRatio}">
                          <div
                            class="img-goods"
                            :class="[$$FormData.image_fill]"
                            :style="{backgroundImage: `url(${item.thumbnail})`}"
                          ></div>
                        </div>
                      </div>
                      <div class="info-goods" :class="[`align-${$$FormData.text_align}`]">
                        <div class="title-goods">
                          <h3
                            v-if="$$FormData.show_goods_name"
                            class="name-goods"
                            :style="{fontWeight: $$FormData.text_font_weight}"
                          >
                            <span v-if="$$FormData.show_goods_self && item.self_operated === 0" class="self">京东</span>
                            <span v-if="$$FormData.show_goods_self && item.self_operated === 1" class="self">自营</span>
                            <span v-if="$$FormData.show_goods_self && item.self_operated === 2" class="self">助农</span>
                            <span v-if="$$FormData.show_goods_self && item.self_operated === 3" class="self">山姆</span>
                            <span v-if="$$FormData.show_goods_self && item.self_operated === 4" class="self">自营</span>
                            <span v-if="$$FormData.show_goods_self && item.self_operated === 5" class="self">永辉</span>
                            <span v-if="$$FormData.show_goods_self && item.self_operated === 6" class="self">美团</span>
                            {{ item.goods_name }}</h3>
                          <p v-if="$$FormData.show_goods_desc && $$FormData.goodsList[$$FormData.goodsList.length - 1].goods_desc" class="desc-goods">
                            {{ item.goods_desc }}
                          </p>
                          <p v-if="$$FormData.show_goods_specs" class="specs-goods">
                            {{ item.specs_name || getSkuList(item.specs) }}
                          </p>
                        </div>
                        <div class="price-goods">
                          <div v-if="$$FormData.show_goods_price" class="price">
                            <span class="currency-price">¥</span>
                            <span class="money-price">{{Number(item.price).toFixed(2)}}</span>
                            <span v-if="$$FormData.show_goods_original_price && item.mktprice" class="original-price">￥{{ item.mktprice }}</span>
                          </div>
                          <div v-if="$$FormData.show_goods_buy_btn" class="buy-btn" :class="['style-' + $$FormData.goods_buy_btn_style]">
                            <i v-if="$$FormData.goods_buy_btn_style === 1" class="van-icon van-icon-cart-circle-o"></i>
                            <i v-if="$$FormData.goods_buy_btn_style === 2" class="van-icon van-icon-add-o"></i>
                            <i v-if="$$FormData.goods_buy_btn_style === 5" class="van-icon van-icon-add"></i>
                            <img v-if="$$FormData.goods_buy_btn_style === 10" class="buy-btn-image" :src="$$FormData.buy_btn_style_image" :alt="$$FormData.buy_btn_style_image">
                            <i v-if="$$FormData.goods_buy_btn_style === 6" class="van-icon van-icon-shopping-cart-o"></i>
                            <button v-else-if="$$FormData.goods_buy_btn_text" class="buy-text">
                              {{ $$FormData.goods_buy_btn_text }}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div v-if="$$FormData.show_goods_badge" class="badge-goods" :class="$$FormData.goods_badge_style">
                        <i v-if="$$FormData.goods_badge_style === 'new'" class="van-icon van-icon-new-arrival"></i>
                        <i v-else-if="$$FormData.goods_badge_style === 'hot'" class="van-icon van-icon-hot-sale"></i>
                        <i v-else-if="$$FormData.goods_badge_style === 'NEW'" class="van-icon van-icon-new"></i>
                        <i v-else-if="$$FormData.goods_badge_style === 'HOT'" class="van-icon van-icon-hot"></i>
                        <img
                          v-else-if="$$FormData.goods_badge_style_image"
                          :src="$$FormData.goods_badge_style_image"
                          :alt="$$FormData.goods_badge_style_image"
                          class="image-badge"
                        >
                        <div v-else class="image-badge no-image">
                          <p>角标</p>
                          <p>区域</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <ul
        class="goods-preview__list"
        :class="[$$FormData.list_style]"
        :style="{
        paddingLeft: ($$FormData.page_edge ) * 0.5 + 'px',
        paddingRight: ($$FormData.page_edge ) * 0.5 + 'px',
        marginLeft: (-($$FormData.goods_space / 2) ) * 0.5 + 'px',
        marginRight: (-($$FormData.goods_space / 2) ) * 0.5 + 'px'
      }"
      >
        <li
          v-for="(item, itemIndex) in ($$FormData.goodsList.length ? $$FormData.goodsList : exampleGoods)"
          :key="itemIndex"
          :class="['item-goods', itemIndex % 2 && 'item-goods-two']"
        >
          <div
            class="a-item-goods"
            :style="{margin: ($$FormData.goods_space / 2 ) * 0.5 + 'px', backgroundColor: $$FormData.goods_background_color, borderColor: $$FormData.goods_border_color}"
            :class="[$$FormData.goods_chamfer, $$FormData.goods_style]"
          >
            <template v-if="$$FormData.list_style === 'column-switch'">
              <template v-if="!(itemIndex % 2)">
                <div class="image-goods"
                     :style="[$$FormData.image_edge && {
                        margin: ($$FormData.image_edge ) * 0.5 + 'px'
                     }, {
                        borderRadius: ($$FormData.image_radius ) * 0.5 + 'px'
                     }]">
                  <div class="image-goods-inner" :style="{paddingTop: imagePaddingTopByRatio}">
                    <div
                      class="img-goods"
                      :class="[$$FormData.image_fill]"
                      :style="{backgroundImage: `url(${item.thumbnail})`}"
                    ></div>
                  </div>
                </div>
              </template>
              <div class="info-goods" :class="[`align-${$$FormData.text_align}`]">
                <div class="title-goods">
                  <h3
                    v-if="$$FormData.show_goods_name"
                    class="name-goods"
                    :style="{fontWeight: $$FormData.text_font_weight}"
                  >
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 0" class="self">京东</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 1" class="self">自营</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 2" class="self">助农</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 3" class="self">山姆</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 4" class="self">自营</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 5" class="self">永辉</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 6" class="self">美团</span>
                    {{ item.goods_name }}</h3>
                  <p v-if="$$FormData.show_goods_desc && item.goods_desc" class="desc-goods">
                    {{ item.goods_desc }}
                  </p>
                  <p v-if="$$FormData.show_goods_specs" class="specs-goods">
                    {{ item.specs_name || getSkuList(item.specs) }}
                  </p>
                </div>
                <div class="price-goods">
                  <div v-if="$$FormData.show_goods_price" class="price">
                    <span class="currency-price">￥</span>
                    <span class="money-price">{{Number(item.price).toFixed(2)}}</span>
                    <span v-if="$$FormData.show_goods_original_price && item.mktprice" class="original-price">￥{{ item.mktprice }}</span>
                  </div>
                  <div v-if="$$FormData.show_goods_buy_btn" class="buy-btn" :class="['style-' + $$FormData.goods_buy_btn_style]">
                    <i v-if="$$FormData.goods_buy_btn_style === 1" class="van-icon van-icon-cart-circle-o"></i>
                    <i v-if="$$FormData.goods_buy_btn_style === 2" class="van-icon van-icon-add-o"></i>
                    <i v-if="$$FormData.goods_buy_btn_style === 5" class="van-icon van-icon-add"></i>
                    <i v-if="$$FormData.goods_buy_btn_style === 6" class="van-icon van-icon-shopping-cart-o"></i>
                    <img v-if="$$FormData.goods_buy_btn_style === 10" class="buy-btn-image" :src="$$FormData.buy_btn_style_image" :alt="$$FormData.buy_btn_style_image">
                    <button v-else-if="$$FormData.goods_buy_btn_text" class="buy-text">
                      {{ $$FormData.goods_buy_btn_text }}
                    </button>
                  </div>
                </div>
              </div>
              <template v-if="(itemIndex % 2)">
                <div class="image-goods"
                     :style="[$$FormData.image_edge && {
                        margin: ($$FormData.image_edge ) * 0.5 + 'px'
                     }, {
                        borderRadius: ($$FormData.image_radius ) * 0.5 + 'px'
                     }]">
                  <div class="image-goods-inner" :style="{paddingTop: imagePaddingTopByRatio}">
                    <div
                      class="img-goods"
                      :class="[$$FormData.image_fill]"
                      :style="{backgroundImage: `url(${item.thumbnail})`}"
                    ></div>
                  </div>
                </div>
              </template>
            </template>
            <template v-else-if="$$FormData.list_style === 'card-coupon'">
              <div class="image-goods"
                   :style="[$$FormData.image_edge && {
                      margin: ($$FormData.image_edge ) * 0.5 + 'px'
                   }, {
                      borderRadius: ($$FormData.image_radius ) * 0.5 + 'px'
                   }]">
                <div
                  :class="['card-coupon-image', $$FormData.image_fill]"
                  :style="{backgroundImage: `url(${item.thumbnail})`}"
                ></div>
              </div>
              <div class="info-goods" :class="[`align-${$$FormData.text_align}`]">
                <div class="title-goods">
                  <h3
                    v-if="$$FormData.show_goods_name"
                    class="name-goods"
                    :style="{fontWeight: $$FormData.text_font_weight}"
                  >
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 0" class="self">京东</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 1" class="self">自营</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 2" class="self">助农</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 3" class="self">山姆</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 4" class="self">自营</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 5" class="self">永辉</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 6" class="self">美团</span>
                    {{ item.goods_name }}</h3>
                  <p v-if="$$FormData.show_goods_desc && item.goods_desc" class="desc-goods">
                    {{ item.goods_desc }}
                  </p>
                  <p v-if="$$FormData.show_goods_specs" class="specs-goods">
                    {{ item.specs_name || getSkuList(item.specs) }}
                  </p>
                </div>
                <div class="price-goods">
                  <div v-if="$$FormData.show_goods_price" class="price">
                    <span class="currency-price">￥</span>
                    <span class="money-price">{{Number(item.price).toFixed(2)}}</span>
                    <span v-if="$$FormData.show_goods_original_price && item.mktprice" class="original-price">￥{{ item.mktprice }}</span>
                  </div>
                  <div v-if="$$FormData.show_goods_buy_btn" class="buy-btn" :class="['style-' + $$FormData.goods_buy_btn_style]">
                    <i v-if="$$FormData.goods_buy_btn_style === 1" class="van-icon van-icon-cart-circle-o"></i>
                    <i v-if="$$FormData.goods_buy_btn_style === 2" class="van-icon van-icon-add-o"></i>
                    <i v-if="$$FormData.goods_buy_btn_style === 5" class="van-icon van-icon-add"></i>
                    <i v-if="$$FormData.goods_buy_btn_style === 6" class="van-icon van-icon-shopping-cart-o"></i>
                    <img v-if="$$FormData.goods_buy_btn_style === 10" class="buy-btn-image" :src="$$FormData.buy_btn_style_image" :alt="$$FormData.buy_btn_style_image">
                    <button v-else-if="$$FormData.goods_buy_btn_text" class="buy-text">
                      {{ $$FormData.goods_buy_btn_text }}
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="image-goods"
                   :style="[$$FormData.image_edge && {
                      margin: ($$FormData.image_edge ) * 0.5 + 'px'
                   }, {
                      borderRadius: ($$FormData.image_radius ) * 0.5 + 'px'
                   }]">
                <div class="image-goods-inner" :style="{paddingTop: imagePaddingTopByRatio}">
                  <div
                    class="img-goods"
                    :class="[$$FormData.image_fill]"
                    :style="{backgroundImage: `url(${item.thumbnail})`}"
                  ></div>
                </div>
              </div>
              <div class="info-goods" :class="[`align-${$$FormData.text_align}`]">
                <div class="title-goods">
                  <h3
                    v-if="$$FormData.show_goods_name"
                    class="name-goods"
                    :style="{fontWeight: $$FormData.text_font_weight}"
                  >
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 0" class="self">京东</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 1" class="self">自营</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 2" class="self">助农</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 3" class="self">山姆</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 4" class="self">自营</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 5" class="self">永辉</span>
                    <span v-if="$$FormData.show_goods_self && item.self_operated === 6" class="self">美团</span>
                    {{ item.goods_name }}</h3>
                  <p v-if="$$FormData.show_goods_desc && item.goods_desc" class="desc-goods">
                    {{ item.goods_desc }}
                  </p>
                  <p v-if="$$FormData.show_goods_specs" class="specs-goods">
                    {{ item.specs_name || getSkuList(item.specs) }}
                  </p>
                </div>
                <div class="price-goods">
                  <div v-if="$$FormData.show_goods_price" class="price">
                    <span class="currency-price">￥</span>
                    <span class="money-price">{{Number(item.price).toFixed(2)}}</span>
                    <span v-if="$$FormData.show_goods_original_price && item.mktprice" class="original-price">￥{{ item.mktprice }}</span>
                  </div>
                  <div v-if="$$FormData.show_goods_buy_btn" class="buy-btn" :class="['style-' + $$FormData.goods_buy_btn_style]">
                    <i v-if="$$FormData.goods_buy_btn_style === 1" class="van-icon van-icon-cart-circle-o"></i>
                    <i v-if="$$FormData.goods_buy_btn_style === 2" class="van-icon van-icon-add-o"></i>
                    <i v-if="$$FormData.goods_buy_btn_style === 5" class="van-icon van-icon-add"></i>
                    <i v-if="$$FormData.goods_buy_btn_style === 6" class="van-icon van-icon-shopping-cart-o"></i>
                    <img v-if="$$FormData.goods_buy_btn_style === 10" class="buy-btn-image" :src="$$FormData.buy_btn_style_image" :alt="$$FormData.buy_btn_style_image">
                    <button v-else-if="$$FormData.goods_buy_btn_text" class="buy-text">
                      {{ $$FormData.goods_buy_btn_text }}
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <div v-if="$$FormData.show_goods_badge" class="badge-goods" :class="$$FormData.goods_badge_style">
              <i v-if="$$FormData.goods_badge_style === 'new'" class="van-icon van-icon-new-arrival"></i>
              <i v-else-if="$$FormData.goods_badge_style === 'hot'" class="van-icon van-icon-hot-sale"></i>
              <i v-else-if="$$FormData.goods_badge_style === 'NEW'" class="van-icon van-icon-new"></i>
              <i v-else-if="$$FormData.goods_badge_style === 'HOT'" class="van-icon van-icon-hot"></i>
              <img
                v-else-if="$$FormData.goods_badge_style_image"
                :src="$$FormData.goods_badge_style_image"
                :alt="$$FormData.goods_badge_style_image"
                class="image-badge"
              >
              <div v-else class="image-badge no-image">
                <p>角标</p>
                <p>区域</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { uuid } from '@/utils/foundation'
export default {
  name: 'GoodsPreview',
  data() {
    return {
      exampleGoods: [
        {
          goods_id: uuid(),
          goods_name: '这里显示商品名称，最多显示1行。',
          goods_desc: '这里显示商品描述，最多显示1行。',
          specs_name: '这里显示商品规格，最多显示1行。',
          thumbnail: require('@/assets/placeholder-image.png'),
          price: 99
        },
        {
          goods_id: uuid(),
          goods_name: '这里显示商品名称，最多显示1行。',
          goods_desc: '这里显示商品描述，最多显示1行。',
          specs_name: '这里显示商品规格，最多显示1行。',
          thumbnail: require('@/assets/placeholder-image.png'),
          price: 99
        },
        {
          goods_id: uuid(),
          goods_name: '这里显示商品名称，最多显示1行。',
          goods_desc: '这里显示商品描述，最多显示1行。',
          specs_name: '这里显示商品规格，最多显示1行。',
          thumbnail: require('@/assets/placeholder-image.png'),
          price: 99
        }
      ],
      current: 1
    }
  },
  computed: {
    /**
     * 通过图片比例计算paddingTop
     * @returns {string}
     */
    imagePaddingTopByRatio() {
      switch (this.$$FormData.image_ratio) {
        case '3:2': return '66.6667%';
        case '1:1': return '100%';
        case '3:4': return '133.333%';
        case '16:9': return '56.25%';
        case '1.9:1': return '52.63%';
      }
      return '66.6667%'
    },
    swiperGoodsList() {
      if (this.$$FormData.goodsList && this.$$FormData.goodsList.length) {
        return [...this.$$FormData.goodsList.slice(-1),...this.$$FormData.goodsList.filter((item, index) => index < 2)]
      } else {
        return this.exampleGoods
      }
    }
  },
  methods: {
    /** 获取规格列表 */
    getSkuList(val) {
      const _val = typeof val === 'string' ? JSON.parse(val) : val
      if (_val) {
        let _specs = []
        _val.forEach(elem => {
          _specs.push(elem.spec_value)
        })
        _specs = _specs.join('/')
        return _specs
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-preview {
  width: 100%;
  overflow: hidden;
  .goods-preview__list {
    &.single {
      .name-goods {
        font-size: 16px;
      }
    }
    &.row-two {
      overflow: hidden;
      .item-goods {
        float: left;
        width: 50%;
      }
      .name-goods {
        height: 34px;
        max-height: 34px;
        font-size: 13px;
        line-height: 17px;
        -webkit-line-clamp: 2
      }
      .desc-goods {
        display: none;
      }
    }
    &.row-three,
    &.row-scroll,
    &.swiper {
      overflow: hidden;
      .item-goods {
        float: left;
        width: 33.333%;
      }
      .info-goods {
        padding: 0 8px 2px;
      }
      .name-goods {
        height: 34px;
        max-height: 34px;
        font-size: 13px;
        line-height: 17px;
        -webkit-line-clamp: 2
      }
      .desc-goods {
        display: none;
      }
      .price-goods .price {
        height: 16px;
        font-size: 16px;
        line-height: 16px;
        font-weight: 600;
      }
      .buy-btn .van-icon {
        height: 20px;
        font-size: 20px;
        line-height: 20px;
      }
      .badge-goods {
        .van-icon {
          font-size: 28px;
        }
        &.new .van-icon {
          top: 1px;
          &::after {
            top: 10px;
            left: 4px;
            width: 20px;
            height: 10px;
          }
        }
        &.hot .van-icon {
          top: 7px;
          left: 0;
          &::after {
            top: 0;
            left: 7px;
            width: 14px;
            height: 27px;
          }
        }
        &.NEW .van-icon {
          top: 0;
          left: 5px;
          font-size: 32px;
          &::after {
            top: 0;
            left: 7px;
            width: 19px;
            height: 23px;
          }
        }
        &.HOT .van-icon {
          top: 5px;
          left: 5px;
          &::after {
            top: 9px;
            left: 7px;
            width: 16px;
            height: 14px;
          }
        }
      }
    }
    &.column {
      .a-item-goods {
        overflow: hidden;
      }
      .image-goods {
        float: left;
        width: 155px;
        height: 155px;
        min-height: auto;
        margin-right: 10px;
        padding-top: initial;
        overflow: hidden;
      }
      .info-goods {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 155px;
        margin-left: 155px;
        padding: 0 12px 0 0;
        overflow: hidden;
        .title-goods {
          margin-top: 0;
        }
      }
      .name-goods {
        max-height: 40px;
        font-size: 14px;
        line-height: 18px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-top: 12px;
        line-height: 20px;
      }
      .desc-goods {
        height: 16px;
        color: #969799;
        font-size: 12px;
        line-height: 16px;
        word-break: break-all;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
    &.column-switch {
      .item-goods {
        &.item-goods-two {
          .image-goods {
            margin-left: 15px;
            margin-right: 0;
            overflow: hidden;
          }
        }
      }
      .a-item-goods {
        display: flex;
        justify-content: center;
      }
      .image-goods {
        width: 100px;
        height: 100px;
        background: #FDF8F3;
        box-shadow: 0 2px 3px 0 rgba(0,0,0,0.14);
        border-radius: 10px;
        margin-right: 15px;
        overflow: hidden;
      }
      .info-goods {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 15px;
      }
      .name-goods {
        max-height: 40px;
        font-size: 14px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-top: 0;
      }
      .price-goods {
        height: auto;
      }
    }
    &.card-coupon {
      .a-item-goods {
        display: flex;
        align-items: center;
        justify-content: center;
        .card-coupon-image {
          height: 55px;
          width: 105px;
          border-radius: 6px;
          background-size: 100% 100%;
        }
        .info-goods {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
          .title-goods {
            flex: 1;
            .name-goods {
              height: 34px;
              max-height: 34px;
              font-size: 13px;
              line-height: 17px;
              -webkit-line-clamp: 2;
              margin: 0 10px;
            }
          }
        }
      }
    }
    &.hybrid {
      .item-goods {
        float: left;
        &:nth-child(3n+1) {
          width: 100%;
        }
        &:nth-child(3n),
        &:nth-child(3n+2){
          width: 50%;
        }
      }
    }
    &.row-scroll {
      display: flex;
      flex-wrap: nowrap;
      margin-bottom: -10px;
      padding-bottom: 10px;
      overflow-x: auto;
      overflow-y: hidden;
      .item-goods {
        flex: 0 0 30%;
        float: none;
        width: 30%;
      }
    }
    &.swiper {
      .name-goods {
        height: 16px;
        font-size: 12px;
        line-height: 16px;
        word-break: break-all;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
  }
  .a-item-goods {
    position: relative;
    display: block;
    box-sizing: border-box;
    //width: 100%;
    min-height: 50px;
    overflow: hidden;
    color: #333333;
    background-color: #ffffff;
    transition: all ease .2s;
    border: 1px solid transparent;
    &.round {
      border-radius: 8px;
    }
    &.card-shadow {
      box-shadow: 0 2px 4px rgba(0,0,0,0.06);
    }
    &.outline-white-bottom {
      border: 1px solid rgba(50,50,51,.1);
    }
    &.transparent {
      background-color: transparent;
      .info-goods {
        padding: 0;
      }
    }
  }
  .item-goods {
    overflow: hidden;
  }
  .image-goods {
    position: relative;
    overflow: hidden;
    .image-goods-inner {
      position: relative;
      max-height: 500px;
      overflow: hidden;
    }
    .img-goods {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      background-repeat: no-repeat;
      background-position: 50%;
      &.cover {
        background-size: cover;
      }
      &.contain {
        background-size: contain;
      }
    }
  }
  .info-goods {
    position: relative;
    padding: 0 12px 4px;
    &.align-center {
      .title-goods {
        text-align: center;
      }
      .price-goods {
        flex-direction: column;
        height: auto;
        .price {
          flex-shrink: 0;
          height: 25px;
          line-height: 25px;
        }
        .buy-btn {
          margin-bottom: 10px;
        }
      }
    }
    .name-goods {
      margin-top: 12px;
      max-height: 20px;
      margin-bottom: 4px;
      color: #323233;
      font-size: 15px;
      line-height: 20px;
      vertical-align: middle;
      word-break: break-all;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .desc-goods, .specs-goods {
      height: 16px;
      color: #969799;
      font-size: 14px;
      line-height: 16px;
      word-break: break-all;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .specs-goods {
      color: #9cb945;
      font-size: 12px;
    }
    .price-goods {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 25px;
      .price {
        height: 20px;
        color: #f84343;
        font-size: 20px;
        line-height: 20px;
        word-break: break-all;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .currency-price {
        align-self: center;
        height: 14px;
        margin-right: 2px;
        font-size: 14px;
      }
      .original-price {
        color: #909399;
        text-decoration: line-through;
        font-size: 13px;
        margin-left: 10px;
      }
    }
    .buy-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      .van-icon {
        color: #f84343;
        font-size: 24px;
        line-height: normal;
        box-sizing: border-box;
      }
      &.style-4 .buy-text,
      &.style-8 .buy-text {
        color: #f84343;
        border-radius: 2px;
        border: 1px solid #f84343;
        background-color: #ffffff;
      }
      &.style-7 .buy-text {
        border-radius: 2px;
      }
      &.style-8 .buy-text {
        border-radius: 24px;
      }
      .buy-text {
        color: #ffffff;
        background-color: #f84343;
        font-size: 12px;
        height: 24px;
        line-height: normal;
        outline: none;
        border: none;
        border-radius: 24px;
        padding: 0 8px;
        box-sizing: border-box;
        transition: all ease .2s;
      }
      .buy-btn-image {
        width: 20px;
        height: 20px;
      }
    }
  }
  .badge-goods {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    &.new .van-icon {
      top: 11px;
      &::after {
        top: 10px;
        left: 4px;
        width: 28px;
        height: 17px;
      }
    }
    &.hot .van-icon {
      top: 10px;
      left: 5px;
      &::after {
        top: 0;
        left: 10px;
        width: 17px;
        height: 35px;
      }
    }
    &.NEW .van-icon {
      left: 4px;
      &::after {
        top: 0;
        left: 7px;
        width: 13px;
        height: 25px;
      }
    }
    &.HOT .van-icon {
      top: 10px;
      left: 10px;
      &::after {
        top: 9px;
        left: 7px;
        width: 24px;
        height: 22px;
      }
    }
    .van-icon {
      position: relative;
      color: #f84343;
      font-size: 38px;
      line-height: normal;
      &::after {
        content: '';
        position: absolute;
        z-index: -1;
        background-color: #ffffff;
      }
    }
    .image-badge {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 36px;
      height: 36px;
      color: #f84343;
      font-size: 12px;
      &.no-image {
        background-color: #86b6cb;
      }
    }
  }
}
.card-coupon-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.swiper-goods-list {
  position: relative;
  width: 100%;
  height: 225px;
  display: flex;
  align-items: center;
  .swiper-goods-item {
    position: absolute;
    top: 25px;
    bottom: 25px;
    left: 25px;
    right: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    transition: all 0.5s ease;
    overflow: hidden;
    &.swiper-active {
      transform: scale(1.3);
    }
  }
}
.swiper-goods-list {
  .uni-swiper-wrapper {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
    transform: translateZ(0);
    .uni-swiper-slides {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      inset: 0 111px;
      .uni-swiper-slide-frame {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        will-change: transform;
        transform: translate(0%, 0px) translateZ(0px);
        .uni-swiper-item {
          display: block;
          overflow: hidden;
          will-change: transform;
          position: absolute;
          width: 100%;
          height: 100%;
          cursor: grab;
          &.uni-swiper-item-1 {
            transform: translate(-100%, 0px) translateZ(0px);
          }
          &.uni-swiper-item-2 {
            transform: translate(0%, 0px) translateZ(0px);
          }
          &.uni-swiper-item-3 {
            transform: translate(100%, 0px) translateZ(0px);
          }
        }
      }
    }
  }
}

.self {
  border-radius: 4px;
  color: #FFFFFF;
  font-size: 10px;
  min-width: 30px;
  text-align: center;
  padding: 2px 4px;
  margin-right: 5px;
  background: linear-gradient(to right, #FD5632 0%, #EF0D25 100%);
}
</style>
